import _ from 'lodash';

import pointInPolygon from '@turf/boolean-point-in-polygon';
import { point } from '@turf/helpers';

const compassDirections = ['NE', 'NW', 'SE', 'SW'];
export function properCase(name) {
    return _(name)
        .replace(/\//g, ' / ')
        .split(/\s+/g)
        .map(word => {
            // Don't transform 'NE' to 'Ne'
            if (compassDirections.indexOf(word) !== -1) {
                return word;
            }
            return _.upperFirst(_.toLower(word));
        })
        .map(word => {
            if (word.indexOf('Mc') === 0) {
                return `Mc${_.upperFirst(word.slice(2))}`;
            }
            if (word.indexOf('Mac') === 0 && word !== 'Macleod') {
                return `Mac${_.upperFirst(word.slice(3))}`;
            }
            return word;
        })
        .map(word => ((word === 'Md') ? 'MD' : word))
        .map(word => ((word === 'Of') ? 'of' : word))
        .join(' ');
}

export function getContainingFeature(geojson, { longitude, latitude }) {
    const pt = point([longitude, latitude]);
    const matchingFeature = geojson.features.find(feature => pointInPolygon(pt, feature));

    return matchingFeature;
}
